import Video = youtube.Video;

interface TutorialVideo {
    id: string;
    author: number;
    description?: string;
}

interface TutorialItem {
    title: string;
    videos: TutorialVideo[];
}

const tutorials: TutorialItem[] = [
    {
        title: 'tutorial.tools',
        videos: [
            {
                id: 'xDWloc9rsNY',
                author: 2,
                description: 'tutorial.tools.desc'
            }
        ]
    },
    {
        title: 'tutorial.shapes',
        videos: [
            {
                id: 'MTvJAbSTkBY',
                author: 2,
                description: 'tutorial.shapes.desc'
            },
            {
                id: 'cp5wTLvL9ak',
                author: 3,
                description: 'tutorial.shapes.desc2'
            }
        ]
    },
    {
        title: 'tutorial.color',
        videos: [
            {
                id: 'pTz8NYBtHlI',
                author: 3,
                description: 'tutorial.color.desc'
            },
            {
                id: 'OsXxDFuDR8Q',
                author: 3,
                description: 'tutorial.color.desc2'
            }
        ]
    },
    {
        title: 'tutorial.layers',
        videos: [
            {
                id: '7J_CtK0FCg8',
                author: 2,
                description: 'tutorial.layers.desc'
            },
            {
                id: 'kHK8MoOIlXg',
                author: 2,
                description: 'tutorial.layers.desc2'
            },
            {
                id: 'W2IGUdnacso',
                author: 3,
                description: 'tutorial.layers.desc3'
            }
        ]
    },
    {
        title: 'tutorial.timeline',
        videos: [
            {
                id: '9QMOI4OxNuI',
                author: 3,
                description: 'tutorial.timeline.desc'
            },
            {
                id: 'SY-B3WxxlJA',
                author: 3,
                description: 'tutorial.timeline.desc2'
            },
            {
                id: 'nhcrJHWaAZ0',
                author: 3,
                description: 'tutorial.timeline.desc3'
            }
        ]
    },
    {
        title: 'tutorial.audio',
        videos: [
            {
                id: '9r4T9OEebNs',
                author: 3,
                description: 'tutorial.audio.desc'
            },
            {
                id: 'lEs4zAZMwi0',
                author: 3,
                description: 'tutorial.audio.desc2'
            }
        ]
    },
    {
        title: 'tutorial.scenes',
        videos: [
            {
                id: 'p3VTKcds15g',
                author: 3,
                description: 'tutorial.scenes.desc'
            }
        ]
    },
    {
        title: 'tutorial.masks',
        videos: [
            {
                id: 'rE6FLLZcySk',
                author: 2,
                description: 'tutorial.masks.desc'
            },
            {
                id: 'EAWycSYrieU',
                author: 2,
                description: 'tutorial.masks.desc2'
            },
            {
                id: 'TGI-NRjarQ8',
                author: 2,
                description: 'tutorial.masks.desc3'
            },
            {
                id: '34vGqfE4o_I',
                author: 2,
                description: 'tutorial.masks.desc4'
            },
        ]
    },
    {
        title: 'tutorial.animation',
        videos: [
            {
                id: 'ytjUqhcOT0U',
                author: 1,
                description: 'tutorial.animation.desc3'
            },
            {
                id: 'YIZ2yWfbryU',
                author: 1,
                description: 'tutorial.animation.desc4'
            },
            {
                id: 'N7337YnRad0',
                author: 1,
                description: 'tutorial.animation.desc5'
            },
            {
                id: 'vcHJSINGLes',
                author: 1,
                description: 'tutorial.animation.desc6'
            },
            {
                id: 'vRvHKfiRNsY',
                author: 2,
                description: 'tutorial.animation.desc'
            },
            {
                id: 'bI3ojD2No54',
                author: 3,
                description: 'tutorial.animation.desc2'
            }
        ]
    },
];

const tips: TutorialVideo[] = [
    {id: 'DNk-oyyvGGk', author: 1},
    {id: '4VJl-ibx9_w', author: 1},
    {id: '7NFutKPFO0s', author: 1},
    {id: 'YHWYN1FsTCQ', author: 1},
    {id: '1wvNdSOubkQ', author: 1},
    {id: 'f7AI_SqcmBE', author: 1},
    {id: '2XHzxe3P61U', author: 1},
    {id: '459VmqWO-lI', author: 1},
    {id: 'pCrda1kArjc', author: 1},
    {id: 'WRsrbQZPhw4', author: 1},
    {id: 'SBifkl7XoKs', author: 1},
    {id: 'pQ0E4Yuaogw', author: 1},
    {id: '9ClIYY5CaH4', author: 1},
    {id: 'iCggDw0PK0M', author: 1},
    {id: 'ADFJloPaosA', author: 1},
    {id: 'cq2CKiZZ3TY', author: 1},
    {id: 'uh7cUGqi-D8', author: 1},
    {id: 'XWsPbdJNJuY', author: 1},
    {id: 'GV0iqA2JkyY', author: 1},
    {id: 'ZDOVHJf7fw4', author: 1},
    {id: 't8-to2eMLjI', author: 1},
    {id: 'KdLwbLvqO84', author: 1},
    {id: 'TlPrzpD_J6M', author: 1},
    {id: 'oHGC_UMJj_w', author: 1},
    {id: 'uRjbOcDLYzU', author: 1},
    {id: 'hWwj9xIt01k', author: 1},
    {id: 'kHL4HH78j3c', author: 1},
    {id: 'E6URrqKbCjk', author: 1},
    {id: 'i6E3wHaobh8', author: 1},
    {id: 'pOMVMXSNypY', author: 1},
    {id: 'ytjUqhcOT0U', author: 1},
    {id: '2sKKDNSBG3Q', author: 1},
    {id: 'qkGIFjwwkoM', author: 1},
    {id: 'D3LG5sL9IZw', author: 1},
    {id: 'QIFi5r8hSww', author: 1},
    {id: 'QpBVQm9wzR8', author: 1},
    {id: 'YMSZtPMTUD4', author: 1},
    {id: 'BoZ3BYNeOpI', author: 1},
    {id: 'e1N5F2VHhvs', author: 1},
    {id: '_s8blVOWbNY', author: 1},
    {id: 'u_R0iTTqqmg', author: 1},
    {id: 'kV2g2vfLzqI', author: 1},
    {id: '-lFarhidnWk', author: 1},
    {id: 'CsL0UEh-1mA', author: 1},
    {id: 'tTbyjARHR5M', author: 1},
    {id: 'CmjFJ2XrpOk', author: 1},
    {id: 'obkvNe8bVTU', author: 1},
    {id: 'aubWACQnh0E', author: 1},
    {id: 'b9ZWochAnog', author: 1},
    {id: '13mGg5gmPL4', author: 1}
];

const walkThus: TutorialVideo[] = [
    {id: 'kRhwrZWWaJI', author: 1},
    {id: 'Q_8YTmE14qU', author: 1},
    {id: 'CSc_tTRKp8s', author: 1},
    {id: 'wmHQVbduoeE', author: 1},
    {id: 'OXBHHXvStqo', author: 1},
    {id: 'IF783XNBoQ0', author: 1},
    {id: 'fTTu5C-79VE', author: 1},
    {id: '_elQmdAy170', author: 1},
    {id: 'uu7O0psuMa0', author: 1}
];

class TutorialsPage {
    tutorialVideos = tutorials;
    tips           = tips;
    walkThus       = walkThus;
}

angular.module('animatronApp.tutorial').component('tutorialsPage', {
    controller: TutorialsPage,
    templateUrl: require('tutorial.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/TutorialComponent.ts